import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from "@material-ui/core";

const ConfirmUserDelete = props => {
    const { open, onClose, onSubmit } = props;
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                Potwierdzenie
            </DialogTitle>
            <DialogContent>
                Czy na pewno chcesz usunąć?
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                >
                    Nie
                </Button>
                <Button
                    color="secondary"
                    onClick={onSubmit}
                >
                    Tak
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ConfirmUserDelete.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func
}

export default ConfirmUserDelete
